module.exports = __webpack_public_path__ + "img/cols1-FL.bbc8b793.png";